export default function ArrayFilter(module) {
    angular.module(module || 'app')
        .filter('arrayFilter', arrayFilter);

    function arrayFilter() {
        return function (array, filters, select) {
            if (!array) {
                return array;
            }
            var result = [];
            if (filters) {
                for (var i = 0; i < array.length; i++) {
                    var keys = Object.keys(filters);
                    var entry = array[i];
                    for (var j = 0; j < keys.length; j++) {
                        var key = keys[j];
                        var value = entry[key];
                        if (filters[key].indexOf(value) > -1) {
                            result.push(entry);
                        }
                    }
                }
            }
            if (select) {
                var newResult = [];
                for (var i = 0; i < result.length; i++) {
                    newResult.push(result[i][select]);
                }
                result = newResult;
            }
            return result;
        }
    }
}